export enum Reactions {
  Like = 'Like',
  Dislike = 'Dislike',
}

export type ReactionType = Reactions | null;
